import type { CSS } from '../../stitches.config';

export type FontSizeProp =
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28;

export const fontSizeCSS = (fontSize?: FontSizeProp): CSS =>
  fontSize != null
    ? {
        fontSize: `$${fontSize}`,
      }
    : {};
